
import {v4 as uuidv4} from "uuid";

// 32位uuid和后端统一
export const getUUID = () =>
    uuidv4()
        .replace(/-/g, '')
        .toUpperCase()
